import React from 'react';
import './style.css';

const SpinStyle = ({ children, ...rest }) => (
  <svg className="spin-style" {...rest}>
    {children}
  </svg>
);
export default SpinStyle;
